<app-change-course-header
  [heading]="'Admin: Course Management: MockExam : List'"
  [showChangeCourse]="true"
  (addMockExam)="AddEditExam()"
></app-change-course-header>

<div class="row mt-4">
  <div class="table-responsive px-0">
    <table class="table table-bordered" #table1>
      <thead class="table-light">
        <tr>
          <th
            sortable="Course_Test_Id"
            (sort)="onSort($event)"
            rowspan="2"
            style="vertical-align: middle; text-align: center; width: 5%; white-space: normal;"
          >
            Course Test ID
            <i *ngIf="sortColumn === 'Course_Test_Id'" class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
          </th>
          <th
            sortable="Mock_Exam_Name"
            (sort)="onSort($event)"
            rowspan="2"
            style="vertical-align: middle; text-align: center; width: 15%; white-space: normal;"
          >
            Exam Name
            <i *ngIf="sortColumn === 'Mock_Exam_Name'" class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
          </th>
          <th
            sortable="Number_Of_Questions"
            (sort)="onSort($event)"
            rowspan="2"
            style="vertical-align: middle; text-align: center; width: 5%; white-space: normal;"
          >
            # of Questions
            <i *ngIf="sortColumn === 'Number_Of_Questions'" class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
          </th>
          <th
            rowspan="2"
            sortable="Mock_Exam_Sequence_Number"
            (sort)="onSort($event)"
            style="vertical-align: middle; text-align: center; width: 5%; white-space: normal;"
          >
            Exam Number
            <i *ngIf="sortColumn === 'Mock_Exam_Sequence_Number'" class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
          </th>
          <th
            rowspan="2"
            sortable="Total_Score"
            (sort)="onSort($event)"
            style="vertical-align: middle; text-align: center; width: 2%"
          >
            Total Score
            <i *ngIf="sortColumn === 'Total_Score'" class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
          </th>
          <th
            rowspan="2"
            sortable="Mock_Exam_Status_Type_Code"
            (sort)="onSort($event)"
            style="vertical-align: middle; text-align: center; width: 5%"
          >
            Status
            <i *ngIf="sortColumn === 'Mock_Exam_Status_Type_Code'" class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
          </th>
          <th
            rowspan="2"
            sortable="Exam_Series_Type_Name"
            (sort)="onSort($event)"
            style="vertical-align: middle; text-align: center; width: 5%"
          >
            Exam Series Type
            <i *ngIf="sortColumn === 'Exam_Series_Type_Name'" class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
          </th>
          <th rowspan="2" class="audit-info-col" style="vertical-align: middle; text-align: center;">
            <div>
              <span>Created By</span>
              <span class="text-muted">&nbsp;/&nbsp;</span>
              <span>Created Time</span>
            </div>
            <div>
              <span>Updated By</span>
              <span class="text-muted">&nbsp;/&nbsp;</span>
              <span>Updated Time</span>
            </div>
          </th>
          <th
            [attr.colspan]="courses && courses.length > 0 ? courses.length : 1"
            style="text-align: center; width: 40%"
          >
            Applicable Course Plan
          </th>
          <th rowspan="2"
              style="
                vertical-align: middle;
                text-align: center;
                width: 30px;
                min-width: 24px;
                max-width: 36px;
                white-space: nowrap;
                overflow: hidden;
                padding: 0;
              ">
            <!-- for icon or checkbox -->
          </th>
        </tr>
        <tr>
          <th 
            *ngFor="let item of courses"
            sortable="{{ item.Description }}"
            class="small-th"
          >
            {{ getPlanNameInitails(item.Description) }}
            <!--
            <i *ngIf="sortColumn === item.Description"
               class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
            -->
          </th>
        </tr>
      </thead>
      
      <tbody>
        <tr *ngFor="let item of mockExams"
        (click)="setSelectedExamId(item.Course_Test_Id)"
        [class.table-primary]="item.Course_Test_Id === selectedRowId"
        >
          <td>{{ item.Course_Test_Id }}</td>
          <td>{{ item.Mock_Exam_Name }}</td>
          <td>{{ item.Number_Of_Questions }}</td>
          <td>{{ item.Mock_Exam_Sequence_Number }}</td>
          <td>{{ item.Total_Score ?? 0 }}</td>
          <td>{{ item.Mock_Exam_Status_Type_Code }}</td>
          <td>{{ item?.Exam_Series_Type_Name }}</td>
          <td>
            <div class="d-flex flex-wrap align-items-center">
              <span>
                <span class="fw-semibold text-md">Created:</span>
                <span class="text-md">{{ item.Created_By || '-' }}</span>
                <span class="text-muted small ms-1">{{ item.Creation_Date | date: 'short' || '-' }}</span>
              </span>
              <span>
                <span class="fw-semibold text-md">Updated:</span>
                <span class="text-md">{{ item.Updated_By || '-' }}</span>
                <span class="text-muted small ms-1">{{ item.Updation_Date | date: 'short' || '-' }}</span>
              </span>
            </div>
          </td>
          <td *ngFor="let course of courses">
            <input
              disabled
              class="form-check-input"
              type="checkbox"
              [checked]="checkedCoursePlan(course.Code, item.Course_Test_Id)"
            />
          </td>
          <td>
            <div class="d-flex gap-2 justify-content-center">
              <i
                class="fa fa-edit pointer-cursor"
                title="Edit Exam"
                (click)="AddEditExam(item)"
              ></i>
              <i
                class="fa fa-link pointer-cursor"
                title="Mock Exam Questions"
                (click)="navigateToMockExamQuestions(item)"
                aria-hidden="true"
              >
              </i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
